import { TaskDeadlineOverviewItem } from "types/Models/task";
import { FilingNode } from "v2/types/filingsDashboard.types";

export const toTaskDeadline = (
  filing: FilingNode,
  entityId: string,
  season: string
): TaskDeadlineOverviewItem => {
  const taskDeadline = {
    entity: { uuid: entityId },
    base_task_template: { uuid: filing.productId ?? "" },
    product_content_type_id: filing.productContentTypeId ?? null,
    cart_item_uuid: filing.cartItemId ?? null,
    alarm_state_id: filing.stateId ?? null,
    season,
    payment_amount: filing.paymentAmount ?? 0,
  };

  return taskDeadline as unknown as TaskDeadlineOverviewItem;
};
